import React, { useState } from "react";

type DefaultImage = "main" | "secondary";

type ViewSettingsProps = {
  changeDefaultImage: (value: DefaultImage) => void;
  isMainImage: boolean;
  isSecondaryImage: boolean;
};

type ViewSettingsProviderProps = ViewSettingsProps | null;

export const ViewSettingsContext = React.createContext<ViewSettingsProviderProps>(null);

export const ViewSettingsProvider: React.FC = ({ children }) => {
  const [defaultImage, setDefaultImage] = useState("main");
  const isMainImage = defaultImage === "main";
  const isSecondaryImage = defaultImage === "secondary";
  const changeDefaultImage = (value: DefaultImage) => {
    setDefaultImage(value);
  };

  return (
    <ViewSettingsContext.Provider
      value={{
        changeDefaultImage,
        isMainImage,
        isSecondaryImage,
      }}
    >
      {children}
    </ViewSettingsContext.Provider>
  );
};
